import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircleXmark, faFileXmark } from '@fortawesome/pro-regular-svg-icons';
import { clearVaccineRecordError } from 'actions/pets/PetsActions';
import { VaccineRecordErrorVariant } from 'actions/pets/PetsErrors';
import { Button } from 'components/UI/Button/Button';
import { IconCircle } from 'components/UI/IconCircle/IconCircle';
import Modal from 'components/UI/Modal/Modal';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

import classes from './VaccineRecordErrorModal.module.scss';

interface VaccineRecordErrorContent {
    icon: IconProp;
    title: string;
    description: string;
}

const contentByVariant: Record<VaccineRecordErrorVariant, VaccineRecordErrorContent> = {
    invalid_vaccine_record: {
        icon: faFileXmark,
        title: 'Invalid File',
        description:
            "We couldn't verify this file as a vaccine record. Please upload a clear photo or PDF of the vaccination certificate."
    },
    unable_to_validate: {
        icon: faCircleXmark,
        title: 'Unable To Validate',
        description:
            "We couldn't verify this file right now. Please try again or upload a different document."
    }
};

interface VaccineRecordErrorModalProps {
    onUploadAgain?: () => void;
}

export const VaccineRecordErrorModal: React.FC<VaccineRecordErrorModalProps> = ({
    onUploadAgain
}) => {
    const dispatch = useDispatch();

    const variant = useSelector((state: RootState) => state.pets.vaccineRecordError);

    const closeHandler = () => {
        dispatch(clearVaccineRecordError());
    };

    const uploadAgainHandler = () => {
        dispatch(clearVaccineRecordError());

        onUploadAgain?.();
    };

    if (!variant) {
        return null;
    }

    const content = contentByVariant[variant];

    return (
        <Modal
            open
            className={classes.root}
            bodyClassName={classes.body}
            headerClassName={classes.header}
            footerClassName={classes.footer}
            footer={
                <>
                    <Button variant="black" onClick={closeHandler}>
                        Cancel
                    </Button>

                    <Button variant="green" onClick={uploadAgainHandler}>
                        Upload Again
                    </Button>
                </>
            }
            onClose={closeHandler}
        >
            <IconCircle size={69} icon={content.icon} />

            <p className={classes.title}>{content.title}</p>

            <p className={classes.description}>{content.description}</p>
        </Modal>
    );
};
